import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=5f16cff6&scoped=true&"
import script from "./EmailInput.vue?vue&type=script&lang=js&"
export * from "./EmailInput.vue?vue&type=script&lang=js&"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=5f16cff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16cff6",
  null
  
)

export default component.exports